/**
 * `963` — *When {button, columnId} clicked*. A click writes the button cell
 * (`{"clicks":N,"changed_at":…}`, `column-value-shapes.md` §button), so the trigger is a
 * `cell.changed` on a `button` column whose `clicks` **increased**. A write that does not
 * increase the count is not a click.
 */
import { z } from 'zod';
import { defineTrigger } from '../block.js';
import { columnRefSchema } from '../values.js';
const clicksOf = (value) => {
    if (typeof value !== 'object' || value === null)
        return 0;
    const clicks = value.clicks;
    return typeof clicks === 'number' && Number.isFinite(clicks) ? clicks : 0;
};
export const buttonClickedParams = z.object({ columnId: columnRefSchema });
export const buttonClickedTrigger = defineTrigger({
    id: '963',
    kind: 'trigger',
    app: 'monday',
    sentencePartial: 'When {button, columnId} clicked',
    paramsSchema: buttonClickedParams,
    requiredColumnTypes: ['button'],
    subscribes: ['cell.changed'],
    references: (params) => [{ kind: 'column', id: params.columnId.columnId, invalid: params.columnId.invalid }],
    matches(event, params) {
        if (event.payload.columnId !== params.columnId.columnId)
            return false;
        return clicksOf(event.payload.value) > clicksOf(event.payload.previousValue);
    },
    outputs(event) {
        return { itemId: event.itemId, boardId: event.boardId, userId: event.actorId };
    },
});
//# sourceMappingURL=963.js.map